
























import { Vue, Component } from 'vue-property-decorator';
@Component
export default class Todo extends Vue {
  bread = [{ name: '我的工作台' }, { name: '通知公告' }];
}
